/**
 * Request builders for custom podcast endpoints not covered by generic JSON:API utilities.
 */

export function getPodcastEpisodes(id: string) {
  return { url: `/api/podcasts/${encodeURIComponent(id)}/episodes` };
}
